<template>
  <div class="bx-content-box bx-typo--content-box bx-typo--content-box-leak-left bx-content-box--discrete">
    <div class="bx-typo--content-continuous-text">
      <h3 class="bx-typo--content-interline-h3">
        E-Mail verschickt
      </h3>
      <p>Schau in dein E-Mail-Postfach und folge den Anweisungen in der E-Mail.</p>
      <p>Falls du innerhalb der nächsten fünf Minuten keine E-Mail bekommst, sieh bitte in deinem Spam-Ordner nach.</p>
    </div>
  </div>
</template>
